import { render, staticRenderFns } from "./PriceRecap.vue?vue&type=template&id=81ac71cc&scoped=true&"
import script from "./PriceRecap.vue?vue&type=script&lang=js&"
export * from "./PriceRecap.vue?vue&type=script&lang=js&"
import style0 from "./PriceRecap.vue?vue&type=style&index=0&id=81ac71cc&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ac71cc",
  null
  
)

export default component.exports